<template>
  <div class="search-box">
    <el-row :class="`form-row`" :style="`height: ${isShowMore ? formRowMaxHeight : formRowMinHeight};`" :gutter="0">
      <div class="col-left" :style="`width: `">
        <el-form ref="form" :model="form" :label-width="`${labelWidth}px`">
          <el-row :gutter="16" class="form-item-row">
            <el-col
              :span="isShowMore ? 8 : renderData.length >= 3 ? 24 : 12"
              v-for="(item, index) in renderData"
              :key="index"
              :class="isShowMore || (!isShowMore && renderData.length >= 3 && index == 0) || (!isShowMore && renderData.length < 3) ? '' : 'width0'"
            >
              <el-form-item v-if="item.type === 'input'" :label="item.label" :prop="item.key">
                <el-input v-if="!item.isNumber" :maxlength="item.maxLength" v-model.trim="form[item.key]" :placeholder="item.placeholder"></el-input>
                <el-input v-else oninput="value=value.replace(/[^\d]/g,'')" :maxlength="item.maxLength" v-model.trim="form[item.key]" :placeholder="item.placeholder"></el-input>
              </el-form-item>
              <el-form-item v-if="item.type === 'select'" :label="item.label" :prop="item.key">
                <el-select clearable collapse-tags filterable :multiple="item.multiple" v-model="form[item.key]" :placeholder="item.placeholder">
                  <el-option
                    v-for="(optionItem, optionIndex) in item.option"
                    :key="optionIndex"
                    :label="item.props && item.props.label ? optionItem[item.props.label] : optionItem.label"
                    :value="item.props && item.props.value ? optionItem[item.props.value] : optionItem.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="item.type === 'date-range'" :label="item.label" :prop="item.key">
                <el-date-picker
                  v-model="form[item.key]"
                  format="yyyy/MM/dd HH:mm:ss"
                  :value-format="item.valueFormat ? item.valueFormat : 'yyyy/MM/dd HH:mm:ss'"
                  type="datetimerange"
                  range-separator=""
                  :start-placeholder="item.placeholder[0]"
                  :end-placeholder="item.placeholder[1]"
                  :default-time="['00:00:00', '23:59:59']"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item v-if="item.type === 'choose-store'" :label="item.label" :prop="item.key">
                <el-cascader
                  v-model="form[item.key]"
                  placeholder="请选择店铺"
                  :options="shopTreeData"
                  filterable
                  :props="shopCascaderProps"
                  clearable
                  collapse-tags
                  :show-all-levels="false"
                >
                </el-cascader>
              </el-form-item>
              <el-form-item v-if="item.type === 'choose-store-single'" :label="item.label" :prop="item.key">
                <el-cascader
                  v-model="form[item.key]"
                  placeholder="请选择店铺"
                  :options="shopTreeData"
                  filterable
                  :props="{
                    ...shopCascaderProps,
                    multiple: false
                  }"
                  clearable
                  :show-all-levels="false"
                >
                </el-cascader>
              </el-form-item>
              <el-form-item v-if="item.type === 'mall'" :label="item.label" :prop="item.key">
                <el-select v-model="form[item.key]" placeholder="请选择商场名称" :multiple="!item.multiple && item.multiple !== false" collapse-tags filterable>
                  <el-option v-for="item in mallList" :label="item.name" :value="item.id" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="col-right" :style="`width: ${isShowMore ? '0px' : '400px'};`">
        <div>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm('form')">重置</el-button>
          <slot name="btn"></slot>
          <el-button type="text" class="more-btn" @click="onMoreSearch" v-if="renderData.length >= 3">
            <span>更多筛选</span>
            <i class="el-icon-arrow-down"></i>
          </el-button>
        </div>
      </div>
    </el-row>
    <div :class="`button-div ${renderData.length >= 3 && isShowMore ? '' : 'height0'}`" :style="`padding-left: ${labelWidth}px;`">
      <el-button type="primary" class="mr10" @click="onSearch">查询</el-button>
      <el-button class="" @click="resetForm('form')">重置</el-button>
      <slot name="btn"></slot>
      <el-button v-if="!unfold" type="text" class="more-btn" @click="onMoreSearch">
        <span>收起</span>
        <i class="el-icon-arrow-up"></i>
      </el-button>
    </div>
  </div>
</template>
<script>
import { api_getConfig } from "@/api/common";
export default {
  name: 'Search',
  props: {
    unfold: {
      type: Boolean,
      default() {
        return false
      }
    },
    labelWidth: {
      type: Number,
      default() {
        return 80
      }
    },
    renderData: {
      type: Array,
      default() {
        return []
      },
    },
    formData: {
      type: Object,
      default() {
        return {}
      },
    }
  },
  data() {
    return {
      storeIdList: [],
      mallList: [], // 商场
      shopTreeData: [], // 店铺级联框树形数据
      shopCascaderProps: {
        multiple: true,
        value: "id",
        label: "name",
        emitPath: false,
      }, // 店铺级联框配置项
      form: {
      },
      formRowMinHeight: '64px', // 筛选框的最小高度
      formRowMaxHeight: '', // 筛选框的最大高度
      isShowMore: false, // 是否展示更多筛选项
    }
  },
  created () {
    this.form = {...this.formData}
    this.isShowMore = this.unfold
    if (this.renderData.length > 3) {
      this.formRowMaxHeight = `${Math.ceil(this.renderData.length / 3) * 54}px`
    } else {
      this.formRowMinHeight = '74px'
    }

    const store = this.renderData.filter(item => item.type === 'choose-store' || item.type === 'choose-store-single')
    const mall = this.renderData.filter(item => item.type === 'mall')
    store.length && this.getConfig_storeThreeLevel() // 获取config_店铺级联
    mall.length && this.getConfig_mall() // 获取config_商场
  },
  methods: {
    // 获取config_店铺级联
    async getConfig_storeThreeLevel() {
      const {storeThreeLevel=[]} = await api_getConfig('storeThreeLevel')
      this.shopTreeData = storeThreeLevel // 店铺级联框数据
    },

    // 获取config_商场
    async getConfig_mall() {
      const {mall=[]} = await api_getConfig('mall')
      this.mallList = mall // 商场
    },

    // formatData (value, item) {
    //   this.form[item.key][0] = this.$moment(value[0]).format('YYYY/MM/DD')
    //   this.form[item.key][1] = this.$moment(value[1]).format('YYYY/MM/DD')
    // },
    onSearch () {
      this.$emit('onSearch', this.form)
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.form = {}
    },
    onMoreSearch() {
      this.isShowMore = !this.isShowMore
    },
  },
  computed: {
  },
  components: {
  },
  watch: {
    formData (n, o) {
      this.form = this.formData
    }
  }
}
</script>
<style lang="scss" scoped>
.search-box{
  // min-height: 186px;
  background-color: #fff;
  border-bottom: 1px solid #cccccc80;
  box-sizing: border-box;
  margin-top: 25px;

  .form-row {
    // height: 64px;
    overflow: hidden;
    display: flex;
    .el-cascader,
    .el-input,
    .el-select,
    .el-input__inner {
      width: 100% !important;
      max-width: 400px;
    }
  }

  .ml80 {
    margin-left: 80px;
  }

  ::v-deep {
    .el-form{
      label{
        font-size: 14px;
      }
      .form-item-row{
        // max-width: calc(100% - 142px);
        display: flex;
        flex-wrap: wrap;
        align-content: space-evenly;
        // justify-content: space-between;
        // min-height: 186px;

        .el-col {
          margin: 10px 0;
          height: 34px;

          &.width0 {
            width: 0;
            padding: 0 !important;
            overflow: hidden;
          }
        }
      }
      .el-form-item{
        margin-bottom: 0;

        .el-form-item__label,
        .el-form-item__content {
          line-height: 34px;

          .el-input__suffix-inner {
            i {
              line-height: 34px;
            }
          }
        }
      }
      .el-select{
        display: block;
      }
      .el-range-editor.el-input__inner{
        width: auto;
        background: #F2F3F5;
        border: 0;
        input{
          background: #F2F3F5;
          border: 0;
        }
      }
      .el-range-editor.el-input__inner.is-active{
        width: auto;
        background: #fff;
        border: 1px solid #05C8AF;
        input{
          background: #fff;
          border: 0;
        }
      }
      .el-input{
        border-radius: 2px;
        font-size: 14px;
        .el-input__inner{
          background: #F2F3F5;
          border: 0;
          height: 34px;
        }
        .el-input__inner:focus{
          background: #fff;
          border: 1px solid #05C8AF;
        }
      }
      .el-input.is-focus+.el-cascader__tags{
        input{
          background: #fff;
        }
      }

      .el-cascader{
        .el-input{
          input{
            height: 34px !important;
          }
        }
      }
      .el-input.is-focus{
        .el-input__inner{
          background: #fff;
          border: 1px solid #05C8AF;
        }
      }
    }
  }

  .form-btn-col {
    display: flex;
    .el-button {
      min-width: 80px !important;
    }
  }
  .button-div{
    height: 34px;
    margin: 10px 0 30px 0;
    overflow: hidden;
    opacity: 1;

    &.height0 {
      height: 0;
      opacity: 0;
      margin: 0;
    }

    .el-button {
      min-width: 80px !important;
    }
  }

  .col-left {
    flex: 1;
  }

  .col-right {
    // width: 300px;
    // background-color: #ccc;
    overflow: hidden;
    height: 34px;
    text-align: right;
    margin: 10px 0;

    .el-button {
      min-width: auto;
      padding: 0 24px;
      margin-right: 0;
      margin-left: 10px;
    }
  }

  .more-btn {
    font-size: 14px;
    padding: 0 !important;
    min-width: auto !important;
    margin-left: 20px !important;

    i {
      margin-left: 10px;
      font-size: 14px;
    }
  }
}
</style>
